import { t } from 'i18next';
import React, { FC } from 'react';
import { Picto } from '../../Picto';

interface NightDayHeaderDayProps {
  dayIndex?: number;
}

const NightDayHeaderDay: FC<NightDayHeaderDayProps> = ({ dayIndex }) => (
  <div className="NightDayHeaderDay" id={`${t('travelPlaner.Travel.day')}${dayIndex || ''}`}>
    <Picto iconKey="itinerary-fr" width="40" height="40" />
    {`${t('travelPlaner.Travel.day')} ${dayIndex || ''}`}
  </div>
);

export default NightDayHeaderDay;
